import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';
// Page imports
import NotFound from './pages/NotFound';
import Home from './pages/Home';
import Register from './pages/Register';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Marketplace from './pages/Marketplace';
import StartTrading from './pages/StartTrading';
import ZlatnaKlauzula from './pages/ZlatnaKlauzula';
import Community from './pages/Community';
import AdminUserManagementDashboard from './pages/admin-user-management-dashboard';
import AdminHub from './pages/AdminHub';
import DesignSystemDocumentation from './pages/design-system-documentation';
import Messages from './pages/Messages';
import ApiSettings from './pages/api-settings';
import ComponentShowcaseDocumentation from './pages/component-showcase-documentation';
import ObjavljPonuduForm from './pages/objavi-ponudu-form';
import OglasnaTablaBoard from './pages/oglasna-tabla-board';
import OfferDetailsDetaljiOglasa from './pages/offer-details-detalji-oglasa';
import MyNegotiationsMojaPregovaranja from './pages/my-negotiations-moja-pregovaranja';
import MyOffersArchive from './pages/my-offers-archive';
import AdminDisputeMediationDashboard from './pages/admin-dispute-mediation-dashboard';
import AdminListingsModerationDashboard from './pages/admin-listings-moderation-dashboard';
import AdminNegotiationsModerationDashboard from './pages/admin-negotiations-moderation-dashboard';
import AdminDiscussionsModerationDashboard from './pages/admin-discussions-moderation-dashboard';
import AdminContentEditor from './pages/admin-content-editor';
import PlatformInstructionsGuide from './pages/uputstva';
import TermsAndConditions from './pages/uslovi-koriscenja';
import PrivacyPolicyPage from './pages/privacy-policy-page';
import ContactPage from './pages/contact-page';
export default function AppRouter() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Main Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/berza" element={<Marketplace />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/zajednica" element={<Community />} />
          <Route path="/community" element={<Community />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/poruke" element={<Messages />} />
          <Route path="/zapocni-trgovinu" element={<StartTrading />} />
          <Route path="/start-trading" element={<StartTrading />} />
          <Route path="/zlatna-klauzula" element={<ZlatnaKlauzula />} />
          {/* Authentication Routes */}
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          {/* User Routes */}
          <Route path="/profil" element={<Profile />} />
          <Route path="/profile" element={<Profile />} />
          {/* Wish/Initiative Routes */}
          {/* NEW: Bulletin Board Route */}
          <Route path="/admin-user-management-dashboard" element={<AdminUserManagementDashboard />} />
          <Route path="/admin-hub" element={<AdminHub />} />
          <Route path="/admin" element={<AdminHub />} />
          {/* Moderation Routes */}
          <Route path="/admin-listings-moderation-dashboard" element={<AdminListingsModerationDashboard />} />
          <Route path="/admin-negotiations-moderation-dashboard" element={<AdminNegotiationsModerationDashboard />} />
          <Route path="/admin-discussions-moderation-dashboard" element={<AdminDiscussionsModerationDashboard />} />
          {/* Profile Synchronization Dashboard Route */}
          {/* API Settings Route */}
          <Route path="/api-settings" element={<ApiSettings />} />
          {/* Design System Route */}
          <Route path="/design-system-documentation" element={<DesignSystemDocumentation />} />
          {/* Component Showcase Route */}
          <Route path="/component-showcase-documentation" element={<ComponentShowcaseDocumentation />} />
          <Route path="/objavi-ponudu-form" element={<ObjavljPonuduForm />} />
          <Route path="/oglasna-tabla-board" element={<OglasnaTablaBoard />} />
          <Route path="/offer-details-detalji-oglasa/:id" element={<OfferDetailsDetaljiOglasa />} />
          <Route path="/my-negotiations-moja-pregovaranja" element={<MyNegotiationsMojaPregovaranja />} />
          <Route path="/my-offers-archive" element={<MyOffersArchive />} />
          <Route path="/admin-dispute-mediation-dashboard" element={<AdminDisputeMediationDashboard />} />
          <Route path="/admin-content-editor" element={<AdminContentEditor />} />
          <Route path="/uputstva" element={<PlatformInstructionsGuide />} />
          <Route path="/uslovi-koriscenja" element={<TermsAndConditions />} />
          <Route path="/privatnost" element={<PrivacyPolicyPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          {/* 404 Route */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}